import Section from '@audioeye-marketing/ui/src/components/Section'
import Container from '@audioeye-marketing/ui/src/components/Container'
import Grid from '@audioeye-marketing/ui/src/components/Grid'
import Stack from '@audioeye-marketing/ui/src/components/Stack'
import Typography from '@audioeye-marketing/ui/src/components/Typography'
import colors from '@audioeye-marketing/ui/src/theme/colors'
import ScannerSection from '@/components/misc/ScannerSection'
import FeaturedArticle from '@/components/misc/FeaturedArticle'
import translateSectionStyles from '@/lib/translate-section-styles'

const PostFooter = async ({ relatedPosts }) => {
  const sectionStyles = translateSectionStyles({ background_color: { value: colors.secondary[900] } })
  const spacing = 4

  return (
    <>
      <ScannerSection />
      <Section {...sectionStyles}>
        <Container constraint="lg">
          <Stack spacing={{ xs: 3.75, md: 5.5 }}>
            <Container leftAlign constraint="sm">
              <Typography level="h3">Continue Reading</Typography>
            </Container>
            <Grid
              container
              component="ul"
              spacing={spacing}
              alignItems="stretch"
              // Negative margin to offset the spacing of the grid items and align to text content
              sx={{
                listStyleType: 'none', // Remove bullets from ul
                paddingLeft: '0', // Remove padding from ul
                marginLeft: `-${spacing * 4}px !important`,
                marginRight: `-${spacing * 4}px !important`,
              }}
            >
              {relatedPosts.map((relatedPost) => {
                return (
                  <Grid
                    key={relatedPost?.uuid}
                    component="li"
                    xs={12}
                    sm={6}
                    md={4}
                    display="flex"
                    justifyContent="center"
                  >
                    <FeaturedArticle data={relatedPost} size="md" />
                  </Grid>
                )
              })}
            </Grid>
          </Stack>
        </Container>
      </Section>
    </>
  )
}

export default PostFooter
